import React from 'react';
import { useTournament } from 'context/TournamentContext';

import TradeHistory from 'components/game/TradeHistory';
import TradeHistoryMargin from 'components/game/TradeHistoryMargin';

import { RowBottom, Box } from './styled';

const BottomSection = (props: { tournamentDetails: any; }) => {
  const { tournamentDetails } = useTournament();
  const rawData: any = tournamentDetails?.data;
  const attributes = rawData?.attributes ?? rawData?.data ?? rawData;
  const tournamentType = attributes?.trade_type;
  return (
    <RowBottom>
      <Box>
        {(tournamentType === 'Margin') ? (
          <TradeHistoryMargin tournamentDetails={tournamentDetails} />
        ) : (
          <TradeHistory tournamentDetails={tournamentDetails} />
        )}
      </Box>
    </RowBottom>
  );
};

export default BottomSection;
